import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import mbtIcon from '../../../../assets/images/bank-transfer-icon.png';
import {
    getLanguageCode, getTranslations, getCustomer, getCsrf
} from '../../../utils/selectors';
import {redirectTo} from '../../../utils/helpers';
import {interpolateTranslation} from '../../../utils/interpolateTranslation';
import SubmitButton from '../../molecules/SubmitButton';
import {confirmPaymentMethod} from '../../../actions/manualBankTransfer/browser';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import {getTransferData} from '../../../actions/manualBankTransfer';


const ManualBankTransfer = ({
    transferData,
    translations,
    languageCode,
    csrfToken,
    match
}) => {
    const {params: {sessionId}} = match;
    const [isLoading, setIsLoading] = useState(false);

    const {
        header,
        body: {stepOne, stepTwo, stepThree},
        button
    } = translations.manualBankTransfer;

    const confirmPaymentMethodAndRedirect = async () => {
        setIsLoading(true);
        if (!sessionId) return;
        const {redirectUrl} = await confirmPaymentMethod(sessionId, languageCode, csrfToken);
        redirectTo(redirectUrl);
    };

    const stepOneFormat = interpolateTranslation(stepOne, {
        amount: `${transferData?.amount} ${transferData.currency}`
    });
    const stepTwoFormat = interpolateTranslation(stepTwo, {
        senderName: `${transferData?.firstName} ${transferData?.lastName}`
    });
    const stepThreeFormat = interpolateTranslation(stepThree, {
        time: `${transferData?.durationInHours}`
    });

    return (
        <div className="manualBankTransfer-main-container">
            <div className="manualBankTransfer-header">
                <h4>{header}</h4>
            </div>
            <div className="manualBankTransfer-img-container">
                <img src={mbtIcon} alt="" />
            </div>
            <div className="manualBankTransfer-body-container">
                <p dangerouslySetInnerHTML={{__html: stepOneFormat}} />
                <p dangerouslySetInnerHTML={{__html: stepTwoFormat}} />
                <p dangerouslySetInnerHTML={{__html: stepThreeFormat}} />
            </div>
            <footer className="manualBankTransfer-footer-container">
                <SubmitButton onClick={() => (!isLoading ? confirmPaymentMethodAndRedirect() : null)}>
                    {button}
                </SubmitButton>
            </footer>
        </div>

    );
};

ManualBankTransfer.getServerSideProps = async (context, store) => {
    try {
        const transferData = await getTransferData(
            context?.params?.sessionId
        );
        return {transferData};
    } catch (error) {
        store.dispatch(genericErrorHasOccurred(true));
        return {transferData: []};
    }
};
ManualBankTransfer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            sessionId: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    translations: PropTypes.shape().isRequired,
    languageCode: PropTypes.string.isRequired,
    transferData: PropTypes.shape().isRequired
};
const mapStateToProps = state => ({
    languageCode: getLanguageCode(state),
    translations: getTranslations(state),
    customer: getCustomer(state),
    csrfToken: getCsrf(state)
});

export default connect(mapStateToProps)(ManualBankTransfer);
